import httpService from "./http.service"

const userService = {
  getUserById: async (userId) => {
    const { data } = await httpService.get("api/users/user/" + userId)
    return data
  },
  passwordRecovery: async (phone) => {
    await httpService.post("api/users/password-recovery", { phone })
  },
  getUsers: async ({
    limit = 500,
    offset = 0,
    signal,
    companyId,
    withTotal = false,
    qId,
    qName,
    qPhone,
    qPosition,
    qRole,
    birthdateFrom,
    birthdateTo,
    employee,
    sort,
    sortDir,
  } = {}) => {
    const params = { limit, offset }
    if (withTotal) params.with_total = 1
    if (qId) params.q_id = qId
    if (qName) params.q_name = qName
    if (qPhone) params.q_phone = qPhone
    if (qPosition) params.q_position = qPosition
    if (qRole) params.q_role = qRole
    if (birthdateFrom) params.birthdate_from = birthdateFrom
    if (birthdateTo) params.birthdate_to = birthdateTo
    if (employee) params.employee = employee
    if (sort) params.sort = sort
    if (sortDir) params.sort_dir = sortDir
    const config = { params, signal }
    if (companyId != null) {
      config.headers = { "X-Company-Id": String(companyId) }
    }
    const { data } = await httpService.get("api/users/", config)
    return data
  },
  getStaffByService: async (serviceId, options = {}) => {
    const params = { staff: 1 }
    if (serviceId != null) params.service_id = serviceId
    const { data } = await httpService.get("api/users/staff/", {
      params,
      signal: options.signal,
    })
    return data
  },
  UpdateCurrentUser: async (data) => {
    const { userId, ...payload } = data
    await httpService.patch(`api/users/user/${userId}/`, payload)
  },
  updateUser: async (userId, payload) => {
    await httpService.patch(`api/users/user/${userId}/`, payload)
  },
  UploadUserImage: async (userId, formData) => {
    await httpService.patch("api/users/image/" + userId, formData)
  },
  createUser: async (payload) => {
    const { data } = await httpService.post("api/users/", payload)
    return data
  },
  deleteUser: async (userId) => {
    const { data } = await httpService.delete(`api/users/user/${userId}/`)
    return data
  },
  deleteUsersBulk: async (ids) => {
    const { data } = await httpService.post("api/users/bulk-delete/", { ids })
    return data
  },
}

export default userService
